import type { FlairColor } from './flairPalette';
import { DarkBackgroundFlairColors, DarkFlairColors, FlairColors } from './flairPalette';

export const getFlairColor = (color: FlairColor, isInverted: boolean, isOnDarkBackground = false): string => {
  if (isInverted) {
    return DarkFlairColors[color];
  }

  if (isOnDarkBackground) {
    return DarkBackgroundFlairColors[color];
  }

  return FlairColors[color];
};
